// import * as PanelNames from '../../Components/CartoLib/Panels/PanelNames';
import {
    LAND_ASSEMBLY,
    PLANNING_ALERTS,
    OWNERSHIP_SEARCH,
    propertyInfo as PROPERTY_INFO,
    dataLayers as DATA_LAYERS,
    SEARCH,
    comparable as COMPARABLE,
    NEW_SKETCHES,
    DRAWN_SKETCHES
} from './PanelNames';

export default {
    [PROPERTY_INFO]: {
        enabled: false,
        compact: false
    },
    [DATA_LAYERS]: {
        enabled: true,
        compact: false
    },
    [SEARCH]: {
        enabled: false,
        compact: false
    },
    [COMPARABLE]: {
        enabled: false,
        compact: false
    },
    [PLANNING_ALERTS]: {
        enabled: false,
        compact: false
    },
    [LAND_ASSEMBLY]: {
        enabled: false,
        compact: false
    },
    [OWNERSHIP_SEARCH]: {
        enabled: false,
        compact: false
    },
    [NEW_SKETCHES]: {
        enabled: false,
        compact: false
    },
    [DRAWN_SKETCHES]: {
        enabled: false,
        compact: false
    }
};
